function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const button = event.currentTarget;
    const previousValue = this.input.value;

    if (button.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

function announceToScreenReader(message, priority = "polite") {
  const announcer = document.createElement("div");
  announcer.setAttribute("role", "status");
  announcer.setAttribute("aria-live", priority);
  announcer.setAttribute("aria-atomic", "true");
  announcer.className = "visually-hidden";
  announcer.textContent = message;
  document.body.appendChild(announcer);
  setTimeout(() => announcer.remove(), 1000);
}

window.SneakersDepot = {
  announce: announceToScreenReader,
  trapFocus: trapFocus,
};

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.activeElement = null;

    if (this.notification) {
      this.notification.addEventListener(
        "keyup",
        (evt) => evt.code === "Escape" && this.close()
      );

      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener("click", this.close.bind(this))
      );
    }
  }

  open() {
    if (!this.notification) return;

    this.notification.classList.add("animate", "active");
    this.notification.setAttribute("aria-hidden", "false");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        if (typeof trapFocus === "function") {
          trapFocus(this.notification);
        }
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);

    setTimeout(() => {
      this.close();
    }, 5000);
  }

  close() {
    if (!this.notification) return;

    this.notification.classList.remove("active");
    this.notification.setAttribute("aria-hidden", "true");
    document.body.removeEventListener("click", this.onBodyClick);

    if (typeof removeTrapFocus === "function") {
      removeTrapFocus(this.activeElement);
    }
  }

  renderContents(parsedState) {
    if (!parsedState) return;

    this.cartItemKey = parsedState.key;

    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (element && parsedState.sections && parsedState.sections[section.id]) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    this.updateCartDrawer(parsedState);

    const continueButton = this.querySelector(".cart-notification__close");
    if (continueButton) {
      continueButton.addEventListener("click", this.close.bind(this));
    }

    if (this.header && typeof this.header.reveal === "function") {
      this.header.reveal();
    }

    this.open();
  }

  updateCartDrawer(parsedState) {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer || !parsedState.sections) return;

    const drawerSections = [
      {
        id: "CartDrawer-CartItems",
        section: "cart-drawer",
        selector: ".drawer__contents",
      },
      {
        id: "CartDrawer-Footer",
        section: "cart-drawer",
        selector: ".drawer__footer",
      },
    ];

    drawerSections.forEach((section) => {
      const element = document.getElementById(section.id);
      const sectionHTML = parsedState.sections[section.section];

      if (element && sectionHTML) {
        const parsed = new DOMParser().parseFromString(
          sectionHTML,
          "text/html"
        );
        const content = parsed.querySelector(section.selector);
        if (content) {
          element.innerHTML = content.innerHTML;
        }
      }
    });

    const cartDrawerItems = cartDrawer.querySelector("cart-drawer-items");
    if (cartDrawerItems) {
      cartDrawerItems.classList.remove("is-empty");
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: "cart-notification-button",
        selector: ".cart-notification__links",
      },
      {
        id: "cart-icon-bubble",
        selector: "#cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const element = parsed.querySelector(selector);
    return element ? element.innerHTML : "";
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.setupCartIconListener();
    this.setupCloseButton();
    this.setupOverlayListener();
  }

  setupCartIconListener() {
    const cartIcon = document.querySelector("#cart-icon-bubble");
    if (!cartIcon) return;

    if (window.location.pathname === "/cart") {
      cartIcon.style.pointerEvents = "none";
      cartIcon.style.opacity = "0.5";
      return;
    }

    cartIcon.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      this.open();
    });
  }

  setupCloseButton() {
    const closeButton = this.querySelector(".drawer__close");
    if (!closeButton) return;

    closeButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.close();
    });
  }

  setupOverlayListener() {
    const overlay = this.querySelector(".cart-drawer__overlay");
    if (!overlay) return;

    overlay.addEventListener("click", (event) => {
      event.preventDefault();
      this.close();
    });
  }

  open() {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${scrollbarWidth}px`;

    const header =
      document.querySelector("sticky-header") ||
      document.querySelector("header");
    if (header) {
      header.style.paddingRight = `${scrollbarWidth}px`;
    }

    requestAnimationFrame(() => {
      this.classList.add("active");
      document.body.classList.add("drawer-open");
    });

    this.dispatchEvent(new CustomEvent("drawerOpen", { bubbles: true }));
  }

  close() {
    this.classList.remove("active");
    document.body.classList.remove("drawer-open");

    setTimeout(() => {
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";

      const header =
        document.querySelector("sticky-header") ||
        document.querySelector("header");
      if (header) {
        header.style.paddingRight = "";
      }
    }, 400);

    this.dispatchEvent(new CustomEvent("drawerClose", { bubbles: true }));
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      if (
        elementToReplace &&
        parsedState.sections &&
        parsedState.sections[section.section]
      ) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "CartDrawer-CartItems",
        section: "cart-drawer",
        selector: ".drawer__contents",
      },
      {
        id: "CartDrawer-Footer",
        section: "cart-drawer",
        selector: ".drawer__footer",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }
}

customElements.define("cart-drawer", CartDrawer);

(function () {
  function overrideJudgeMeStyles() {
    var widget = document.querySelector(".jdgm-widget.jdgm-cards-carousel");
    if (widget) {
      widget.style.setProperty("--max-width", "2560px", "important");
      widget.style.setProperty("--width-xs", "280px", "important");
      widget.style.setProperty("--width-sm", "320px", "important");
      widget.style.setProperty("--width-md", "360px", "important");
      widget.style.setProperty("--width-lg", "400px", "important");
      widget.style.setProperty("--width-xl", "400px", "important");
      widget.style.maxWidth = "2560px";
      widget.style.width = "100%";
      widget.style.margin = "0 auto";
      widget.style.padding = "0";
    }

    var pageWidth = document.querySelector(".page-width:has(.jdgm-widget)");
    if (pageWidth) {
      pageWidth.style.maxWidth = "2560px";
      pageWidth.style.margin = "0 auto";
      pageWidth.style.padding = "0";
    }

    var cardsWrapper = document.querySelector(
      ".jdgm-widget .jdgm-cards-wrapper"
    );
    if (cardsWrapper) {
      cardsWrapper.style.maxWidth = "2560px";
      cardsWrapper.style.width = "100%";
    }

    var header = document.querySelector(".jdgm-widget .jdgm-header");
    if (header) {
      header.style.display = "flex";
      header.style.justifyContent = "space-between";
      header.style.alignItems = "flex-end";
      header.style.padding = "24px 30px";
      header.style.borderTop = "none";
      header.style.width = "100%";
      header.style.boxSizing = "border-box";
    }

    var title = document.querySelector(".jdgm-widget .jdgm-title");
    if (title) {
      title.style.fontFamily = "'Barlow', sans-serif";
      title.style.fontSize = "16px";
      title.style.fontWeight = "400";
      title.style.color = "#000000BF";
      title.style.textTransform = "capitalize";
      title.style.letterSpacing = "0";
      title.style.margin = "0";
      title.style.flex = "1";
      title.style.textAlign = "left";
    }

    var headerInfo = document.querySelector(".jdgm-widget .jdgm-header-info");
    if (headerInfo) {
      headerInfo.style.display = "flex";
      headerInfo.style.alignItems = "center";
      headerInfo.style.gap = "16px";
      headerInfo.style.flexShrink = "0";
    }

    var cards = document.querySelectorAll(".jdgm-widget .jdgm-card");
    cards.forEach(function (card) {
      card.style.minWidth = "320px";
      card.style.maxWidth = "400px";
      card.style.minHeight = "280px";
      card.style.padding = "24px";
      card.style.boxSizing = "border-box";
    });

    var content = document.querySelector(".jdgm-widget .jdgm-content");
    if (content) {
      content.style.minHeight = "320px";
    }

    var videosContainer = document.querySelector(
      ".jdgm-widget .jdgm-videos-container"
    );
    if (videosContainer) {
      var firstRealCard = videosContainer.querySelector(
        '.jdgm-card[data-card-index="0"]:not(.jdgm-clone-before):not(.jdgm-clone-after)'
      );
      if (firstRealCard) {
        var offset = firstRealCard.offsetLeft;
        videosContainer.style.transform = "translateX(-" + offset + "px)";
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", overrideJudgeMeStyles);
  } else {
    overrideJudgeMeStyles();
  }

  window.addEventListener("load", overrideJudgeMeStyles);
  setTimeout(overrideJudgeMeStyles, 1000);
  setTimeout(overrideJudgeMeStyles, 2000);
})();

(function () {
  "use strict";

  function getCardWidth() {
    var w = window.innerWidth;
    if (w >= 1400) return 100 / 6;
    if (w >= 1200) return 20;
    if (w >= 990) return 25;
    if (w >= 750) return 33.333;
    return 50;
  }

  function applyStyles() {
    var widget = document.querySelector(".jdgm-widget.jdgm-cards-carousel");
    if (!widget) return;

    var section = widget.closest(".shopify-section");
    if (section) {
      section.style.cssText =
        "max-width:100%!important;width:100%!important;padding:0!important;margin:0!important;";
    }

    var pageWidth = widget.closest(".page-width");
    if (pageWidth) {
      pageWidth.style.cssText =
        "max-width:100%!important;width:100%!important;padding:0!important;margin:0!important;";
    }

    var block = widget.closest(".shopify-block");
    if (block) {
      block.style.cssText =
        "max-width:100%!important;width:100%!important;padding:0!important;margin:0!important;";
    }

    widget.style.cssText =
      "width:100vw!important;max-width:100vw!important;margin:0!important;margin-left:calc(-50vw + 50%)!important;padding:0!important;background:#fff!important;font-family:Barlow,sans-serif!important;border-radius:0!important;";

    var header = widget.querySelector(".jdgm-header");
    if (header) {
      var isMobile = window.innerWidth < 750;
      header.style.cssText =
        "display:flex!important;justify-content:space-between!important;align-items:" +
        (isMobile ? "flex-start" : "center") +
        "!important;flex-direction:" +
        (isMobile ? "column" : "row") +
        "!important;gap:" +
        (isMobile ? "12px" : "20px") +
        "!important;padding:" +
        (isMobile ? "16px 20px" : "20px 40px") +
        "!important;margin:0!important;border-top:2px solid #000!important;border-bottom:none!important;background:#fff!important;";
    }

    var title = widget.querySelector(".jdgm-title");
    if (title) {
      var fontSize =
        window.innerWidth < 750
          ? "20px"
          : window.innerWidth < 990
          ? "28px"
          : "40px";
      title.style.cssText =
        "font-family:Barlow,sans-serif!important;font-size:" +
        fontSize +
        "!important;font-weight:400!important;color:#000!important;margin:0!important;padding:0!important;line-height:1.1!important;text-transform:none!important;";
    }

    var headerInfo = widget.querySelector(".jdgm-header-info");
    if (headerInfo) {
      headerInfo.style.cssText =
        "display:flex!important;align-items:center!important;gap:12px!important;flex-wrap:wrap!important;margin:0!important;";
    }

    var avgRating = widget.querySelector(".jdgm-average-rating");
    if (avgRating) {
      avgRating.style.cssText =
        "display:flex!important;align-items:center!important;gap:8px!important;";
    }

    var ratingText = widget.querySelector(".jdgm-rating-text");
    if (ratingText) {
      ratingText.style.cssText =
        "font-family:Barlow,sans-serif!important;font-size:14px!important;font-weight:500!important;color:#000!important;";
    }

    var badge = widget.querySelector(".jdgm-verified-badge-header");
    if (badge) {
      badge.style.cssText =
        "display:flex!important;align-items:center!important;gap:6px!important;padding:6px 12px!important;background:#000!important;border:none!important;border-radius:0!important;";
    }

    var checkmark = widget.querySelector(".jdgm-verified-checkmark");
    if (checkmark) {
      checkmark.style.cssText =
        "width:12px!important;height:12px!important;fill:#fff!important;";
    }

    var verifiedText = widget.querySelector(".jdgm-verified-text");
    if (verifiedText) {
      verifiedText.style.cssText =
        "font-family:Barlow,sans-serif!important;font-size:10px!important;font-weight:700!important;text-transform:uppercase!important;letter-spacing:0.08em!important;color:#fff!important;";
    }

    var stars = widget.querySelectorAll(".jdgm-star");
    stars.forEach(function (star) {
      var isOn = star.classList.contains("jdgm--on");
      var isOff = star.classList.contains("jdgm--off");
      if (isOff) {
        star.style.cssText =
          "background:#fff!important;color:#000!important;padding:2px!important;margin:0 1px!important;font-size:9px!important;border:1px solid #000!important;border-radius:0!important;display:inline-block!important;";
      } else {
        star.style.cssText =
          "background:#000!important;color:#fff!important;padding:2px!important;margin:0 1px!important;font-size:9px!important;border:none!important;border-radius:0!important;display:inline-block!important;";
      }
    });

    var starsContainers = widget.querySelectorAll(".jdgm-stars");
    starsContainers.forEach(function (container) {
      container.style.cssText =
        "display:flex!important;gap:1px!important;align-items:center!important;";
    });

    var arrows = widget.querySelectorAll(".jdgm-arrow");
    arrows.forEach(function (arrow) {
      arrow.style.cssText = "display:none!important;";
    });

    var content = widget.querySelector(".jdgm-content");
    if (content) {
      var contentHeight = window.innerWidth < 750 ? "260px" : "320px";
      content.style.cssText =
        "height:" +
        contentHeight +
        "!important;overflow:hidden!important;padding:0!important;margin:0!important;border-top:2px solid #000!important;border-bottom:2px solid #000!important;background:#fff!important;width:100%!important;";
    }

    var wrapper = widget.querySelector(".jdgm-cards-wrapper");
    if (wrapper) {
      wrapper.style.cssText =
        "height:100%!important;width:100%!important;overflow:hidden!important;margin:0!important;padding:0!important;";
    }

    var container = widget.querySelector(".jdgm-videos-container");
    if (container) {
      container.style.cssText =
        "height:100%!important;display:flex!important;flex-wrap:nowrap!important;padding:0!important;margin:0!important;align-items:stretch!important;";
    }

    var cardWidth = getCardWidth();
    var isMobileCard = window.innerWidth < 750;
    var cards = widget.querySelectorAll(".jdgm-card");

    cards.forEach(function (card) {
      card.style.cssText =
        "flex:0 0 " +
        cardWidth +
        "vw!important;width:" +
        cardWidth +
        "vw!important;min-width:" +
        cardWidth +
        "vw!important;max-width:" +
        cardWidth +
        "vw!important;height:100%!important;padding:" +
        (isMobileCard ? "16px" : "24px") +
        "!important;margin:0!important;background:#fff!important;border:none!important;border-right:2px solid #000!important;box-sizing:border-box!important;display:flex!important;flex-direction:column!important;border-radius:0!important;";

      var text = card.querySelector(".jdgm-text");
      if (text) {
        text.style.cssText =
          "flex:1!important;padding:0!important;margin:0 0 " +
          (isMobileCard ? "12px" : "16px") +
          " 0!important;overflow:hidden!important;background:transparent!important;border:none!important;";
      }

      var p = card.querySelector(".jdgm-text p");
      if (p) {
        p.style.cssText =
          "font-family:Barlow,sans-serif!important;font-size:" +
          (isMobileCard ? "13px" : "14px") +
          "!important;font-weight:400!important;line-height:1.5!important;color:#000!important;margin:0!important;padding:0!important;display:-webkit-box!important;-webkit-line-clamp:" +
          (isMobileCard ? "4" : "5") +
          "!important;-webkit-box-orient:vertical!important;overflow:hidden!important;";
      }

      var ratingSection = card.querySelector(".jdgm-rating-section");
      if (ratingSection) {
        ratingSection.style.cssText =
          "margin-top:auto!important;padding:" +
          (isMobileCard ? "12px" : "16px") +
          " 0 0 0!important;border:none!important;border-top:1px solid #000!important;background:transparent!important;display:flex!important;flex-direction:column!important;gap:" +
          (isMobileCard ? "6px" : "8px") +
          "!important;";
      }

      var reviewerInfo = card.querySelector(".jdgm-reviewer-info");
      if (reviewerInfo) {
        reviewerInfo.style.cssText =
          "display:flex!important;align-items:center!important;";
      }

      var reviewerName = card.querySelector(".jdgm-reviewer-name");
      if (reviewerName) {
        reviewerName.style.cssText =
          "font-family:Barlow,sans-serif!important;font-size:" +
          (isMobileCard ? "11px" : "12px") +
          "!important;font-weight:600!important;color:#000!important;text-transform:uppercase!important;letter-spacing:0.03em!important;";
      }

      var productName = card.querySelector(".jdgm-product-name");
      if (productName) {
        productName.style.cssText = "display:none!important;";
      }
    });
  }

  function init() {
    var widget = document.querySelector(".jdgm-widget.jdgm-cards-carousel");
    if (widget) {
      applyStyles();
    } else {
      setTimeout(init, 100);
      return;
    }

    var observer = new MutationObserver(function () {
      applyStyles();
    });

    observer.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    var resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(applyStyles, 100);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
(function () {
  "use strict";

  function getCardWidth() {
    var w = window.innerWidth;
    if (w >= 1600) return 100 / 7;
    if (w >= 1400) return 100 / 6;
    if (w >= 1200) return 20;
    if (w >= 990) return 25;
    if (w >= 750) return 33.333;
    return 50;
  }

  function applyStyles() {
    var widget = document.querySelector(".jdgm-widget.jdgm-cards-carousel");
    if (!widget) return;

    var section = widget.closest(".shopify-section");
    if (section) {
      section.style.cssText =
        "max-width:100%!important;width:100%!important;padding:0!important;margin:0!important;";
    }

    var pageWidth = widget.closest(".page-width");
    if (pageWidth) {
      pageWidth.style.cssText =
        "max-width:100%!important;width:100%!important;padding:0!important;margin:0!important;";
    }

    var block = widget.closest(".shopify-block");
    if (block) {
      block.style.cssText =
        "max-width:100%!important;width:100%!important;padding:0!important;margin:0!important;";
    }

    widget.style.cssText =
      "width:100vw!important;max-width:100vw!important;margin:0!important;margin-left:calc(-50vw + 50%)!important;padding:0!important;background:#fff!important;font-family:Barlow,sans-serif!important;border-radius:0!important;";

    var header = widget.querySelector(".jdgm-header");
    if (header) {
      var isMobile = window.innerWidth < 750;
      header.style.cssText =
        "display:flex!important;justify-content:space-between!important;align-items:" +
        (isMobile ? "flex-start" : "center") +
        "!important;flex-direction:" +
        (isMobile ? "column" : "row") +
        "!important;gap:" +
        (isMobile ? "12px" : "20px") +
        "!important;padding:" +
        (isMobile ? "16px 20px" : "20px 40px") +
        "!important;margin:0!important;border-top:2px solid #000!important;border-bottom:none!important;background:#fff!important;";
    }

    var title = widget.querySelector(".jdgm-title");
    if (title) {
      var fontSize =
        window.innerWidth < 750
          ? "20px"
          : window.innerWidth < 990
          ? "28px"
          : "40px";
      title.style.cssText =
        "font-family:Barlow,sans-serif!important;font-size:" +
        fontSize +
        "!important;font-weight:400!important;color:#000!important;margin:0!important;padding:0!important;line-height:1.1!important;text-transform:none!important;";
    }

    var headerInfo = widget.querySelector(".jdgm-header-info");
    if (headerInfo) {
      headerInfo.style.cssText =
        "display:flex!important;align-items:center!important;gap:12px!important;flex-wrap:wrap!important;margin:0!important;";
    }

    var avgRating = widget.querySelector(".jdgm-average-rating");
    if (avgRating) {
      avgRating.style.cssText =
        "display:flex!important;align-items:center!important;gap:8px!important;";
    }

    var ratingText = widget.querySelector(".jdgm-rating-text");
    if (ratingText) {
      ratingText.style.cssText =
        "font-family:Barlow,sans-serif!important;font-size:14px!important;font-weight:500!important;color:#000!important;";
    }

    var badge = widget.querySelector(".jdgm-verified-badge-header");
    if (badge) {
      badge.style.cssText =
        "display:flex!important;align-items:center!important;gap:6px!important;padding:6px 12px!important;background:#000!important;border:none!important;border-radius:0!important;";
    }

    var checkmark = widget.querySelector(".jdgm-verified-checkmark");
    if (checkmark) {
      checkmark.style.cssText =
        "width:12px!important;height:12px!important;fill:#fff!important;";
    }

    var verifiedText = widget.querySelector(".jdgm-verified-text");
    if (verifiedText) {
      verifiedText.style.cssText =
        "font-family:Barlow,sans-serif!important;font-size:10px!important;font-weight:700!important;text-transform:uppercase!important;letter-spacing:0.08em!important;color:#fff!important;";
    }

    var stars = widget.querySelectorAll(".jdgm-star");
    stars.forEach(function (star) {
      var isOff = star.classList.contains("jdgm--off");
      if (isOff) {
        star.style.cssText =
          "background:#fff!important;color:#000!important;padding:2px!important;margin:0 1px!important;font-size:9px!important;border:1px solid #000!important;border-radius:0!important;display:inline-block!important;";
      } else {
        star.style.cssText =
          "background:#000!important;color:#fff!important;padding:2px!important;margin:0 1px!important;font-size:9px!important;border:none!important;border-radius:0!important;display:inline-block!important;";
      }
    });

    var starsContainers = widget.querySelectorAll(".jdgm-stars");
    starsContainers.forEach(function (container) {
      container.style.cssText =
        "display:flex!important;gap:1px!important;align-items:center!important;";
    });

    var content = widget.querySelector(".jdgm-content");
    if (content) {
      var contentHeight = window.innerWidth < 750 ? "280px" : "320px";
      content.style.cssText =
        "height:" +
        contentHeight +
        "!important;overflow:hidden!important;padding:0!important;margin:0!important;border-top:2px solid #000!important;border-bottom:2px solid #000!important;background:#fff!important;width:100%!important;position:relative!important;";
    }

    var isMobile = window.innerWidth < 750;
    var arrows = widget.querySelectorAll(".jdgm-arrow");
    arrows.forEach(function (arrow, index) {
      if (isMobile) {
        var isLeft = index === 0;
        arrow.style.cssText =
          "display:flex!important;align-items:center!important;justify-content:center!important;position:absolute!important;top:50%!important;transform:translateY(-50%)!important;" +
          (isLeft ? "left:8px" : "right:8px") +
          "!important;z-index:10!important;width:36px!important;height:36px!important;background:#000!important;border:none!important;border-radius:0!important;cursor:pointer!important;padding:0!important;";

        var svg = arrow.querySelector("svg");
        if (svg) {
          svg.style.cssText =
            "width:12px!important;height:12px!important;fill:#fff!important;";
        }
        var path = arrow.querySelector("path");
        if (path) {
          path.style.cssText = "fill:#fff!important;";
        }
      } else {
        arrow.style.cssText = "display:none!important;";
      }
    });

    var wrapper = widget.querySelector(".jdgm-cards-wrapper");
    if (wrapper) {
      wrapper.style.cssText =
        "height:100%!important;width:100%!important;overflow:hidden!important;margin:0!important;padding:0!important;";
    }

    var container = widget.querySelector(".jdgm-videos-container");
    if (container) {
      container.style.cssText =
        "height:100%!important;display:flex!important;flex-wrap:nowrap!important;padding:0!important;margin:0!important;align-items:stretch!important;";
    }

    var cardWidth = getCardWidth();
    var isMobileCard = window.innerWidth < 750;
    var cards = widget.querySelectorAll(".jdgm-card");

    cards.forEach(function (card) {
      card.style.cssText =
        "flex:0 0 " +
        cardWidth +
        "vw!important;width:" +
        cardWidth +
        "vw!important;min-width:" +
        cardWidth +
        "vw!important;max-width:" +
        cardWidth +
        "vw!important;height:100%!important;padding:" +
        (isMobileCard ? "16px" : "24px") +
        "!important;margin:0!important;background:#fff!important;border:none!important;border-right:2px solid #000!important;box-sizing:border-box!important;display:flex!important;flex-direction:column!important;border-radius:0!important;";

      var text = card.querySelector(".jdgm-text");
      if (text) {
        text.style.cssText =
          "flex:1!important;padding:0!important;margin:0 0 " +
          (isMobileCard ? "12px" : "16px") +
          " 0!important;overflow:hidden!important;background:transparent!important;border:none!important;";
      }

      var p = card.querySelector(".jdgm-text p");
      if (p) {
        p.style.cssText =
          "font-family:Barlow,sans-serif!important;font-size:" +
          (isMobileCard ? "13px" : "14px") +
          "!important;font-weight:400!important;line-height:1.5!important;color:#000!important;margin:0!important;padding:0!important;display:-webkit-box!important;-webkit-line-clamp:" +
          (isMobileCard ? "4" : "5") +
          "!important;-webkit-box-orient:vertical!important;overflow:hidden!important;";
      }

      var ratingSection = card.querySelector(".jdgm-rating-section");
      if (ratingSection) {
        ratingSection.style.cssText =
          "margin-top:auto!important;padding:" +
          (isMobileCard ? "12px" : "16px") +
          " 0 0 0!important;border:none!important;border-top:1px solid #000!important;background:transparent!important;display:flex!important;flex-direction:column!important;gap:" +
          (isMobileCard ? "6px" : "8px") +
          "!important;";
      }

      var reviewerInfo = card.querySelector(".jdgm-reviewer-info");
      if (reviewerInfo) {
        reviewerInfo.style.cssText =
          "display:flex!important;align-items:center!important;";
      }

      var reviewerName = card.querySelector(".jdgm-reviewer-name");
      if (reviewerName) {
        reviewerName.style.cssText =
          "font-family:Barlow,sans-serif!important;font-size:" +
          (isMobileCard ? "11px" : "12px") +
          "!important;font-weight:600!important;color:#000!important;text-transform:uppercase!important;letter-spacing:0.03em!important;";
      }

      var productName = card.querySelector(".jdgm-product-name");
      if (productName) {
        productName.style.cssText = "display:none!important;";
      }
    });
  }

  function init() {
    var widget = document.querySelector(".jdgm-widget.jdgm-cards-carousel");
    if (widget) {
      applyStyles();
    } else {
      setTimeout(init, 100);
      return;
    }

    var observer = new MutationObserver(function () {
      applyStyles();
    });

    observer.observe(widget, {
      childList: true,
      subtree: true,
      attributes: true,
    });

    var resizeTimeout;
    window.addEventListener("resize", function () {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(applyStyles, 100);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
